<template>
  <v-col xs="10">
    <v-card class="mx-auto" max-width="350">
      <v-card-text>
        <v-row>
          <v-col xs="6">
            <v-row no-gutters>
              <v-col xs="12">
                <v-btn
                  color="#ffdfde"
                  width="100%"
                  height="120"
                  :retain-focus-on-click="false"
                  @click="openCollectDialog"
                >
                  <v-img
                    max-width="60"
                    src="../assets/images/icons/icon-01.png"
                  ></v-img>
                </v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col align="center">
                <v-card class="pa-2" flat>
                  {{ trans.pickup_btn }}
                </v-card>
              </v-col>
            </v-row>
          </v-col>
          <v-col sm="6">
            <v-row no-gutters>
              <v-col xs="12">
                <v-btn
                  color="#fdcb8e"
                  width="100%"
                  height="120"
                  :retain-focus-on-click="false"
                  @click="openStoreDialog"
                >
                  <v-img
                    max-width="80"
                    src="../assets/images/icons/icon-02.png"
                  ></v-img>
                </v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col align="center">
                <v-card class="pa-2" flat>
                  {{ trans.deposit_btn }}
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <CollectModal
      :dialog="dialogCollect"
      :locker="locker"
      :rules="rules"
      :trans="trans.pickup"
      v-on:getLocker="callApiGetLocker"
      v-on:openLocker="callApiOpenLocker"
      v-on:close="
        dialogCollect.show = false;
        dialogCollect.step = 1;
      "
    />
    <StoreModal
      :dialog="dialogStore"
      :locker="locker"
      :rules="rules"
      :sizes="sizes"
      :trans="trans.deposit"
      v-on:authen="callApiAuthen"
      v-on:getDropoffCode="callApiGetDropoffCode"
      v-on:checkDropoffCode="callApiCheckDropoffCode"
      v-on:openLocker="callApiOpenLocker"
      v-on:getLockerCellSize="callApiGetLockerCellSize"
      v-on:cancelDropoff="callApiCancelDropoff"
      v-on:sendNotification="callApiSendNotification"
      v-on:close="closeStoreDialog"
    />
    <AlertModal :dialog="dialogAlert" v-on:close="dialogAlert.show = false" />
    <LoadingModal :show="loading" />
  </v-col>
</template>
<script>
import { mask } from "vue-the-mask";
import axios from "axios";
import qs from "qs";
import CollectModal from "./Modal/CollectModal";
import StoreModal from "./Modal/StoreModal";
import AlertModal from "./Modal/AlertModal";
import LoadingModal from "./Modal/LoadingModal";
export default {
  components: {
    CollectModal,
    StoreModal,
    AlertModal,
    LoadingModal,
  },
  directives: { mask },
  props: {
    rules: Object,
    options: Object,
    url: String,
    urlLockerService: String,
    urlTranslatorService: String,
    secret: Object,
  },
  data() {
    return {
      valid: false,
      config: {},
      dialogCollect: {
        show: false,
        step: 1,
      },
      dialogStore: {
        show: false,
        step: 1,
        userType: "",
        reopen: 0,
        subStep: 0,
        reset: false,
        addcellflag: 0,
        completedropflag: 0,
      },
      dialogAlert: {
        show: false,
        errMsg: "",
      },
      loading: false,
      pickupType: "",
      step: 1,
      reopen: 0,
      locker: {
        id: "",
        otp: "",
        cells: [],
        totals: 0,
      },
      sizes: {
        cellssizes: [],
      },
      auth: {
        projectid: "",
        username: "",
        usertype: "",
        statuscode: "",
        statusdesc: "",
      },
      dropoffcode: "",
      trans: {
        pickup_btn: "",
        deposit_btn: "",
        deposit: {
          title: "",
          step_1: "",
          step_2: "",
          step_3: "",
          step_4: "",
        },
        pickup: {
          title: ""
        }
      },
    };
  },
  mounted() {
    this.config = this.options;
    this.secret.site =
      this.$route.query.site != undefined ? this.$route.query.site : "A007";
    // this.$router.push("/");
    this.setLang();
    this.$root.$on("change lang", () => {
      this.setLang();
    });
  },
  methods: {
    setLang() {
      // read cookie
      let lang = 'en';
      if (document.cookie.split(';').some((item) => item.includes('lang=th'))) {
        lang = 'th';
      }
      this.callApiTranslator(lang);
    },
    openCollectDialog() {
      this.dialogCollect.show = true;
    },
    openStoreDialog() {
      this.dialogStore.show = true;
    },
    closeStoreDialog(state) {
      if (state == 4) {
        if (this.dialogStore.userType == "JT") {
          this.dialogStore.step = 1;
        } else if (this.dialogStore.userType == "DM") {
          this.dialogStore.step = 2;
        }
      } else {
        this.dialogStore.show = false;
        this.dialogStore.step = 1;
      }
    },
    callApiOpenLocker(cell, mode) {
      let overrideMode = this.pickupType == "MK" ? "M" : mode;
      this.loading = true;
      if (this.secret.items == null) {
        this.config["url"] = this.urlLockerService;
        this.config["data"] = qs.stringify({
          projectid: this.secret.site,
          lockerid: this.locker.id,
          cellno: cell.cellno,
          passcode: cell.passcode,
          mode: overrideMode,
          action: "open_cell_locker",
        });
        axios(this.config)
          .then((response) => {
            this.dialogStore.addcellflag = 1;
            if (response.data.statuscode == "00") {
              this.dialogStore.completedropflag = 1;
              this.$root.$emit("open cell", cell.cellno);
              this.locker.totals = this.locker.totals - 1;
            } else {
              this.dialogAlert.errMsg = response.data.statusdesc;
              this.dialogAlert.show = true;
            }
          })
          .catch(() => {
            this.dialogAlert.errMsg = this.trans.error_msg;
            this.dialogAlert.show = true;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    callApiGetLocker(pickupCode) {
      this.loading = true;
      if (this.secret.items == null) {
        this.config["url"] = this.urlLockerService;
        this.config["data"] = qs.stringify({
          projectid: this.secret.site,
          pickupcode: pickupCode,
          action: "get_locker_for_pickup",
        });
        axios(this.config)
          .then((response) => {
            if (response.data.statuscode == "00") {
              this.pickupType = response.data.pickuptype;
              this.locker.id = response.data.lockerid;
              this.locker.cells = response.data.cells;
              this.locker.totals = this.locker.cells.length;
              if (this.pickupType == "MP") {
                this.dialogCollect.step = 2;
                this.locker.otp = response.data.otp;
              } else if (this.pickupType == "PP" || this.pickupType == "MK") {
                this.dialogCollect.step = 3;
              }
            } else {
              this.dialogAlert.errMsg = response.data.statusdesc;
              this.dialogAlert.show = true;
            }
          })
          .catch(() => {
            this.dialogAlert.errMsg = this.trans.error_msg;
            this.dialogAlert.show = true;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    callApiAuthen(username) {
      this.loading = true;
      if (this.secret.items == null) {
        this.config["url"] = this.urlLockerService;
        this.config["data"] = qs.stringify({
          projectid: this.secret.site,
          username: username,
          action: "authen_user",
        });
        axios(this.config)
          .then((response) => {
            if (response.data.statuscode == "00") {
              this.pickupType = "";
              this.auth.projectid = response.data.projectid;
              this.auth.username = response.data.username;
              this.auth.usertype = response.data.usertype;
              if (this.auth.usertype == "JT") {
                this.dialogStore.step = 2;
                this.dialogStore.userType = "JT";
              } else if (this.auth.usertype == "DM") {
                this.dialogStore.step = 2;
                this.dialogStore.userType = "DM";
              }
            } else {
              this.dialogAlert.errMsg = response.data.statusdesc;
              this.dialogAlert.show = true;
            }
          })
          .catch(() => {
            this.dialogAlert.errMsg = this.trans.error_msg;
            this.dialogAlert.show = true;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    callApiGetDropoffCode(username, phoneno) {
      this.loading = true;
      if (this.secret.items == null) {
        this.config["url"] = this.urlLockerService;
        this.config["data"] = qs.stringify({
          projectid: this.secret.site,
          username: username,
          phoneno: phoneno,
          action: "get_dropoff_code",
        });
        axios(this.config)
          .then((response) => {
            if (response.data.statuscode == "00") {
              this.dropoffcode = response.data.dropoffcode;
              this.callApiGetLockerCellSize(username, this.dropoffcode);
            } else {
              this.dialogAlert.errMsg = response.data.statusdesc;
              this.dialogAlert.show = true;
            }
          })
          .catch(() => {
            this.dialogAlert.errMsg = this.trans.error_msg;
            this.dialogAlert.show = true;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    callApiCheckDropoffCode(username, dropoffcode) {
      this.loading = true;
      this.dropoffcode = dropoffcode;
      if (this.secret.items == null) {
        this.config["url"] = this.urlLockerService;
        this.config["data"] = qs.stringify({
          projectid: this.secret.site,
          username: username,
          dropoffcode: this.dropoffcode,
          action: "check_dropoff_code",
        });
        axios(this.config)
          .then((response) => {
            if (response.data.statuscode == "00") {
              this.dialogStore.reopen = response.data.reopen;
              this.locker.id = response.data.lockerid;
              this.locker.cells = response.data.cells;
              this.locker.totals = this.locker.cells.length;
              this.dialogStore.step = 3;
              if (this.dialogStore.reopen == 1) {
                this.dialogStore.subStep = 1;
              } else {
                this.callApiGetLockerCellSize(username, this.dropoffcode);
              }
            } else {
              this.dialogAlert.errMsg = response.data.statusdesc;
              this.dialogAlert.show = true;
            }
          })
          .catch(() => {
            this.dialogAlert.errMsg = this.trans.error_msg;
            this.dialogAlert.show = true;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    callApiGetLockerCellSize(username, dropoffcode) {
      this.loading = true;
      if (dropoffcode.length > 0) {
        this.dropoffcode = dropoffcode;
      }
      if (this.secret.items == null) {
        this.config["url"] = this.urlLockerService;
        this.config["data"] = qs.stringify({
          projectid: this.secret.site,
          username: username,
          dropoffcode: this.dropoffcode,
          action: "get_locker_cell_size",
        });
        axios(this.config)
          .then((response) => {
            if (response.data.statuscode == "00") {
              this.dialogStore.reopen = response.data.reopen;
              this.locker.id = response.data.lockerid;
              if (response.data.cellssizes == undefined) {
                this.sizes.cellssizes = [
                  {
                    size: "S",
                    cellno: "0",
                    passcode: 1234,
                  },
                  {
                    size: "M",
                    cellno: "1",
                    passcode: 1111,
                  },
                  {
                    size: "L",
                    cellno: "2",
                    passcode: 1234,
                  },
                ];
              } else {
                this.sizes.cellssizes = response.data.cellssizes;
              }
              this.dialogStore.step = 3;
              this.dialogStore.subStep = 2;
              this.dialogStore.reset = true;
              this.dialogStore.completedropflag =
                response.data.completedropflag;
              this.dialogStore.addcellflag = response.data.addcellflag;
            } else {
              this.dialogAlert.errMsg = response.data.statusdesc;
              this.dialogAlert.show = true;
            }
          })
          .catch(() => {
            this.dialogAlert.errMsg = this.trans.error_msg;
            this.dialogAlert.show = true;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    callApiCancelDropoff(cell, username, dropoffcode) {
      this.loading = true;
      if (dropoffcode.length > 0) {
        this.dropoffcode = dropoffcode;
      }
      if (this.secret.items == null) {
        this.config["url"] = this.urlLockerService;
        this.config["data"] = qs.stringify({
          projectid: this.secret.site,
          lockerid: this.locker.id,
          username: username,
          dropoffcode: this.dropoffcode,
          cellno: cell.cellno,
          passcode: cell.passcode,
          action: "cancel_dropoff",
        });
        axios(this.config)
          .then((response) => {
            if (response.data.statuscode == "00") {
              // this.$root.$emit("open cell", cell.cellno);
            } else {
              this.dialogAlert.errMsg = response.data.statusdesc;
              this.dialogAlert.show = true;
            }
          })
          .catch(() => {
            this.dialogAlert.errMsg = this.trans.error_msg;
            this.dialogAlert.show = true;
          })
          .finally(() => {
            this.loading = false;
            this.callApiGetLockerCellSize(username, dropoffcode);
          });
      }
    },
    callApiSendNotification(username, dropoffcode) {
      if (dropoffcode.length > 0) {
        this.dropoffcode = dropoffcode;
      }
      this.loading = true;
      if (this.secret.items == null) {
        this.config["url"] = this.urlLockerService;
        this.config["data"] = qs.stringify({
          projectid: this.secret.site,
          username: username,
          dropoffcode: this.dropoffcode,
          action: "send_notification_to_receiver",
        });
        axios(this.config)
          .then((response) => {
            // if (response.data.statuscode == "00") {
            this.dialogStore.userType = response.data.usertype;
            this.dialogStore.step = 4;
            this.dialogStore.subStep = -1;
            // if (response.data.userType == 'JT') {

            // } else if (response.data.userType == 'DM') {

            // }
            // } else {
            //   this.dialogAlert.errMsg = response.data.statusdesc;
            //   this.dialogAlert.show = true;
            // }
          })
          .catch(() => {
            this.dialogAlert.errMsg = this.trans.error_msg;
            this.dialogAlert.show = true;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    callApiTranslator(cookieLang) {
      let lang = this.$route.query.lang != undefined ? this.$route.query.lang : cookieLang;
      document.cookie = "lang=" + lang;
      let config = [];
      config["url"] = this.urlTranslatorService + "?lang=" + lang;
      config["method"] = "get";
      axios(config)
        .then((response) => {
          this.trans = response.data;
        })
        .catch((e) => {
          this.dialogAlert.errMsg = this.trans.error_msg;
          this.dialogAlert.show = true;
        });
    },
  },
};
</script>
<style scope>
.modal-icon {
  margin-right: 8px;
}
.v-card__title {
  padding: 16px 16px 10px !important;
}
.v-stepper--alt-labels .v-stepper__header .v-divider {
  margin: 35px -35px 0;
}
</style>
